import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import MuiTypography from '@mui/material/Typography';
import 'react';
import { ReactComponent as ForwardRef } from '../../../assets/icons/InfoSmall.svg.js';
import { labeledSettingTypes } from '../types.js';
import Tooltip from '../../Tooltip/Tooltip.js';
import Notification from '../../Notification/Notification.js';
import TextField from '../TextField/TextField.js';
import SelectField from '../SelectField/SelectField.js';
import MultiSelectField from '../MultiSelectField/MultiSelectField.js';
import DateRangeField from '../DateRangeField/DateRangeField.js';
import BooleanField from '../BooleanField/BooleanField.js';
import DateField from '../DateField/DateField.js';

// TODO: Change props type to:
// (props: FieldProps & { field: IField & { type: Type } })
// When all type fields have been implemented
const fieldTypeToComponent = {
    Text: TextField,
    Select: SelectField,
    MultiSelect: MultiSelectField,
    Date: DateField,
    DateRange: DateRangeField,
    Boolean: BooleanField,
};
const Container = styled('div', {
    shouldForwardProp: prop => ['children'].includes(prop),
}) `
  display: grid;
  grid-template-columns: 136px auto;
  margin-bottom: 16px;
  grid-column-gap: 8px;
  align-items: ${({ hasError }) => (hasError ? 'baseline' : 'center')};
`;
const LabelContainer = styled('div') `
  color: ${({ theme }) => theme.palette.N20.main};
  display: flex;
  align-items: center;
`;
const Label = styled(MuiTypography) `
  color: ${({ theme }) => theme.palette.N20.main};
  max-width: 110px;
`;
const IconContainer = styled('div') `
  display: inline-flex;
  margin-left: 4px;
  cursor: pointer;
`;
const InputContainer = styled('div') `
  display: flex;
  flex-direction: column;
  grid-row-gap: 2px;
  & > div {
    width: 100%;
  }
`;
const Field = ({ field, value, onChange, error }) => {
    var _a;
    const Component = fieldTypeToComponent[field.type];
    const shouldRenderLabel = labeledSettingTypes.includes(field.type);
    return (jsxs(Container, Object.assign({ hasError: !!error, className: 'field-container' }, { children: [shouldRenderLabel ? (jsxs(LabelContainer, Object.assign({ "data-testid": "label-container" }, { children: [jsxs(Label, Object.assign({ variant: "body1" }, { children: [(_a = field.meta) === null || _a === void 0 ? void 0 : _a.label, field.required && jsx(Fragment, { children: " *" })] })), field.description && (jsx(Tooltip, Object.assign({ title: field.description, duration: "immediate", placement: "right" }, { children: jsx(IconContainer, { children: jsx(ForwardRef, { "data-testid": "infoIcon" }) }) })))] }))) : (jsx("span", {})), jsxs(InputContainer, Object.assign({ "data-testid": `field_${field.key}` }, { children: [jsx(Component, { field: field, value: value, onChange: onChange, error: error }), error && jsx(Notification, Object.assign({ type: "error" }, { children: error }))] }))] })));
};

export { Field as default };
//# sourceMappingURL=Field.js.map
